import { useHotkeys } from 'react-hotkeys-hook';
import { animated } from 'react-spring';
import styled from 'styled-components';
import Button from 'ui/Button/Button';
import RectangleHorizontalThinIcon from '@ingka/ssr-icon/paths/rectangle-horizontal-thin';
import RotateLeftIcon from '@ingka/ssr-icon/paths/rotate-left';
import ArrowLeftIcon from '@ingka/ssr-icon/paths/arrow-left';
import ArrowRightIcon from '@ingka/ssr-icon/paths/arrow-right';
import ArrowDownIcon from '@ingka/ssr-icon/paths/arrow-down';
import { useSelector } from 'react-redux';
import { EkrisFeature } from './EkrisFeature';
import { usePlannerConfig } from 'contexts/plannerConfig';
import { isGameEnabled } from './ekrisReducer';

const Container = styled(animated.div)`
  position: fixed;
  z-index: 20;
  bottom: 0;
  left: calc(50% - (${props => props.theme.layout.sidebarWidth} / 2));
  transform: translate(-50%, 0%);
  margin: 0 auto 1.5rem;
  padding: 0 ${({ theme }) => theme.space.xs};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ColoredContainer = styled(Container)`
  background: #fff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1), 0 8px 8px rgba(0, 0, 0, 0.04);
  border-radius: ${({ theme }) => theme.space.xl};
  padding: 1rem;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`;

const EkrisControls = () => {
  const ekrisEnabled = useSelector(isGameEnabled);
  const {
    plannerConfig: { features }
  } = usePlannerConfig();
  const ekrisFeature = features.find(feature => feature.id === 'Ekris')?.feature;

  const handleClickSpace = () => {
    (ekrisFeature as EkrisFeature)?.getGame()?.hardDrop();
  };

  const handleClickUp = () => {
    (ekrisFeature as EkrisFeature)?.getGame()?.rotateClockWise();
  };

  const handleClickLeft = () => {
    (ekrisFeature as EkrisFeature)?.getGame()?.moveLeft();
  };

  const handleClickRight = () => {
    (ekrisFeature as EkrisFeature)?.getGame()?.moveRight();
  };

  const handleClickDown = () => {
    (ekrisFeature as EkrisFeature)?.getGame()?.moveDown();
  };

  useHotkeys('left', () => handleClickLeft());
  useHotkeys('right', () => handleClickRight());
  useHotkeys('space', () => handleClickSpace());
  useHotkeys('up', () => handleClickUp());
  useHotkeys('down', () => handleClickDown());

  return ekrisEnabled ? (
    <ColoredContainer data-testid="ekris-controls-menu">
      <ButtonWrapper style={{ marginBottom: '1rem' }}>
        <Button
          dataTestId="MoveLeft"
          type="emphasised"
          onClick={() => handleClickLeft()}
          size={'small'}
          ssrIcon={ArrowLeftIcon}
          text="Move left"
        />
        <Button
          dataTestId="Rotate"
          type="emphasised"
          onClick={() => handleClickUp()}
          size={'small'}
          ssrIcon={RotateLeftIcon}
          text="Rotate"
        />
        <Button
          dataTestId="MoveRight"
          type="emphasised"
          onClick={() => handleClickRight()}
          size={'small'}
          ssrIcon={ArrowRightIcon}
          text="Move right"
        />
      </ButtonWrapper>
      <ButtonWrapper>
        <Button
          style={{ width: '50%' }}
          dataTestId="MoveDown"
          type="emphasised"
          onClick={() => handleClickDown()}
          size={'small'}
          ssrIcon={ArrowDownIcon}
          text="Move down"
        />
        <Button
          style={{ width: '50%' }}
          dataTestId="HardDrop"
          type="emphasised"
          onClick={() => handleClickSpace()}
          size={'small'}
          ssrIcon={RectangleHorizontalThinIcon}
          text="Hard drop down"
        />
      </ButtonWrapper>
    </ColoredContainer>
  ) : (
    <></>
  );
};
export default EkrisControls;
